/**
 * Maps the app pathname to the silo button label (Analyze, Generate, …).
 * Nested routes such as /generate/chatgpt still resolve to "Generate".
 *
 * @param {string} pathname - `location.pathname`
 * @returns {"Analyze"|"Brief"|"Generate"|"Audience"|"Activate"|null}
 */
export function getActiveSiloModeFromPathname(pathname) {
  if (!pathname) return null;
  if (pathname.includes("analyze")) return "Analyze";
  if (pathname.includes("brief")) return "Brief";
  if (pathname.includes("generate")) return "Generate";
  if (pathname.includes("audience")) return "Audience";
  if (pathname.includes("activate")) return "Activate";
  return null;
}

/** File attachments are supported on Home (default silo) and Brief. */
export function canUseChatAttachments(pathname, selectedSiloIsDefault) {
  return Boolean(
    selectedSiloIsDefault ||
      getActiveSiloModeFromPathname(pathname) === "Brief",
  );
}
